import React from 'react';
import ThemeToggle from '../theme/ThemeToggle';
import { useTheme } from '../../context/ThemeContext';

const AdminHeader: React.FC = () => {
  const { darkMode } = useTheme();
  
  const iconPath = darkMode
    ? '/assets/logos/NU-DATA-7+-+icon+-+dark.png'
    : '/assets/logos/NU-DATA-6+-+icon+-+light.png';
  
  return (
    <header className="bg-admin-color-secondary-50 dark:bg-admin-color-secondary-900 border-b border-gray-200 dark:border-gray-700">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <img
              className="h-8 w-8"
              src={iconPath}
              alt="NU-DATA Icon"
            />
            <h1 className="ml-2 text-lg font-medium text-admin-color-secondary-800 dark:text-admin-color-secondary-200">
              Admin Portal
            </h1>
          </div>
          <div className="flex items-center">
            <div className="ml-4 flex items-center md:ml-6">
              <ThemeToggle />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
